import { useQuery } from "@tanstack/react-query";
import { getEvaluariDupaCui } from "@/api/endpoints/notificari";
import { queryKeys } from "@/lib/queryClient";

export function useGetEvaluariDupaCui(
  cui: string | null,
  options?: { enabled?: boolean }
) {
  return useQuery({
    queryKey: queryKeys.evaluari.byCui(cui ?? ""),
    queryFn: () => getEvaluariDupaCui(cui!),
    enabled: (options?.enabled ?? true) && !!cui,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
}
